import { useState, useEffect } from "react";
import { ReactComponent as Close } from "../../Assets/icon/close.svg";
import { ReactComponent as Email } from "../../Assets/icon/envelope.svg";
import { ReactComponent as Right } from "../../Assets/icon/chevron-right.svg";
import { ReactComponent as RightArrow } from "../../Assets/images/arrow-right.svg";
import PhoneInput from "react-phone-number-input";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import { addlicensedusers } from "../../Services/subscription";
import {
  deleteConnection,
  sendInviteWithEmailRelationID,
  sendJoinInvite,
  updateConnectionEmail,
} from "../../Services/Realtionship";
import "./style.css";

const InvitePopup = ({
  onClose,
  relationId,
  name,
  onEmailPhoneSubmit,
  listedMembers = 1,
  currentMemberIndex = 0,
  onMemberComplete,
  isOnBoarding,
  isOnlyInvite,
  isUpdate,
}) => {
  const [activeTab, setActiveTab] = useState(isOnlyInvite ? "email" : null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [showConfirmationOnInvite, setShowConfirmationOnInvite] =
    useState(false);

  const [errorMsgToBeShownOnInvite, seterrorMsgToBeShownOnInvite] =
    useState("");

  const [errorMsg, seterrorMsg] = useState("");

  // Store all members' contact details
  const [memberDetails, setMemberDetails] = useState([]);

  // Track current member being edited
  const [currentIndex, setCurrentIndex] = useState(currentMemberIndex);

  useEffect(() => {
    setTimeout(() => {
      seterrorMsg("");
    }, 3000);
  }, [errorMsg]);
  // Initialize member details when component mounts
  useEffect(() => {
    const initialMembers = Array(listedMembers)
      .fill()
      .map(() => ({
        phone: "",
        email: "",
        phoneObj: { code: null, contact: null },
      }));
    setMemberDetails(initialMembers);
  }, [listedMembers]);

  const parsePhoneNumber = (phoneValue) => {
    if (!phoneValue) return { code: null, contact: null };

    try {
      const parsedPhoneNumber = parsePhoneNumberFromString(phoneValue);
      if (!parsedPhoneNumber) return { code: null, contact: null };

      return {
        code: `+${parsedPhoneNumber.countryCallingCode}`,
        contact: parsedPhoneNumber.nationalNumber,
      };
    } catch (error) {
      console.error("Error parsing phone number:", error);
      return { code: null, contact: null };
    }
  };

  const handlePhoneChange = (value) => {
    const parsedPhone = parsePhoneNumber(value);

    const updatedMembers = [...memberDetails];

    // Initialize the current member if it doesn't exist
    if (!updatedMembers[currentIndex]) {
      updatedMembers[currentIndex] = {
        phone: "",
        email: "",
        phoneObj: { code: null, contact: null },
      };
    }

    // Set the phone value and the parsed object
    updatedMembers[currentIndex].phone = value;
    updatedMembers[currentIndex].phoneObj = parsedPhone;

    setMemberDetails(updatedMembers);
  };

  const handleEmailChange = (value) => {
    const updatedMembers = [...memberDetails];

    // Initialize the current member if it doesn't exist
    if (!updatedMembers[currentIndex]) {
      updatedMembers[currentIndex] = {
        phone: "",
        email: "",
        phoneObj: { code: null, contact: null },
      };
    }

    updatedMembers[currentIndex].email = value;
    setMemberDetails(updatedMembers);
  };

  const handleNext = async () => {
    const currentMember = memberDetails[currentIndex];
    if (isUpdate) {
      await updateConnectionEmail(relationId, currentMember?.email)
        .then((res) => {
          onClose({ function: "success", msg: res?.message });
        })
        .catch((err) => {
          if (
            err?.response?.data?.status_code === 404 &&
            err?.response?.data?.message ===
              "The given email is not registered on Aris. Do you want to delete the connection?"
          ) {
            seterrorMsgToBeShownOnInvite(err?.response?.data?.message);
            setShowConfirmationOnInvite(true);
          } else {
            seterrorMsg(
              err?.response?.data?.message || "Something went wrong !!"
            );
          }
        });
    } else if (isOnlyInvite && !isUpdate) {
      await sendInviteWithEmailRelationID(relationId, currentMember?.email)
        .then((res) => {
          onClose({ function: "success" });
        })
        .catch((err) => {
          if (
            err?.response?.data?.status_code === 404 &&
            err?.response?.data?.message ===
              "The given email is not registered on Aris. Would you like to invite them to join Aris?"
          ) {
            seterrorMsgToBeShownOnInvite(err?.response?.data?.message);
            setShowConfirmationOnInvite(true);
          } else {
            seterrorMsg(
              err?.response?.data?.message || "Something went wrong !!"
            );
          }
        });
    } else {
      let formattedContact = null;

      if (activeTab === "sms" && currentMember?.phoneObj) {
        const { code, contact } = currentMember.phoneObj;
        formattedContact = {
          phone: code && contact ? { code, contact } : null,
        };
      } else if (activeTab === "email" && currentMember?.email) {
        formattedContact = {
          email: currentMember.email,
        };
      }

      // Pass single member data to parent if needed
      if (onEmailPhoneSubmit && formattedContact) {
        onEmailPhoneSubmit({
          ...formattedContact,
          memberIndex: currentIndex,
        });
      }

      if (currentIndex < listedMembers - 1) {
        // Move to next member
        setCurrentIndex(currentIndex + 1);
        setActiveTab(null); // Reset tab selection for next member

        if (onMemberComplete) {
          onMemberComplete();
        }
      } else {
        // All members completed
        let formattedUserCred = memberDetails?.map((member) => {
          return {
            email: member?.email,
            mobile: {
              code: member?.phoneObj?.code,
              contact: member?.phoneObj?.contact,
            },
          };
        });
        if (isOnBoarding) {
          onEmailPhoneSubmit(formattedUserCred);
        } else {
          addlicensedusers({
            licensed_users_count: listedMembers,
            payment_method: "card",
          }).then((res) => {
            window.location.href = res?.payload?.checkout_url;
          });
        }

        handleSubmitAll();
      }
    }
  };

  const handleSubmitAll = () => {
    setIsSubmitting(true);

    // Format all member details
    const formattedMembers = memberDetails
      .map((member) => {
        const contactInfo = {};

        if (member?.phoneObj) {
          const { code, contact } = member.phoneObj;
          if (code && contact) {
            contactInfo.phone = { code, contact };
          }
        }

        if (member?.email) {
          contactInfo.email = member.email;
        }

        return contactInfo;
      })
      .filter(
        (member) =>
          (member.phone?.code && member.phone?.contact) || member.email
      );

    // Show success message
    setShowSuccess(true);

    // Close modal after delay
    setTimeout(() => {
      onClose();
    }, 2000);

    setIsSubmitting(false);
  };

  const isNextDisabled = () => {
    const currentMember = memberDetails[currentIndex];

    if (!currentMember) return true;

    if (activeTab === "sms") {
      return !(currentMember.phoneObj?.code && currentMember.phoneObj?.contact);
    } else if (activeTab === "email") {
      // Email validation using regex
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

      return !currentMember.email || !emailRegex.test(currentMember.email);
    }

    return true; // Disabled if no tab is selected
  };

  const onCancelConfirmation = () => {
    setShowConfirmationOnInvite(false);
  };

  const sendInvite = async () => {
    const currentMember = memberDetails[currentIndex];
    // if (isOnlyInvite) {
    //   await sendInviteWithEmailRelationID(relationId, currentMember?.email)
    const invitePayload = {
      relationship_id: relationId,
      primary_email: currentMember?.email,
      send_email: true,
      // primary_contact: null,
      // primary_country_code: null,
      // extra_emails: [],
      // extra_contacts: [],
    };

    if (isUpdate) {
      try {
        await deleteConnection(relationId);
        onClose({
          function: "success",
          msg: "Connection deleted successfully",
        });
      } catch (error) {
        console.error("Error deleting relationship:", error);
        onClose({ function: "fail", msg: "Unable to deleted connection" });
      }
      return;
    } else {
      await sendJoinInvite(invitePayload)
        .then((res) => {
          onClose({ function: "success" });
        })
        .catch((err) => {
          seterrorMsg(err?.response?.data?.message || "something went wrong");
          console.error(err);
        });
    }
  };

  return (
    <div className="join-aris-overlay">
      <div
        className="join-aris-modal"
        style={{ paddingBottom: showConfirmationOnInvite && "2px" }}
      >
        {showSuccess ? (
          <div className="flex items-center justify-center h-full">
            <div className="text-center p-6 bg-green-50 rounded-lg">
              <p className="text-green-700 text-lg font-medium">
                All members added successfully!
              </p>
            </div>
          </div>
        ) : showConfirmationOnInvite ? (
          <>
            <div className="join-aris-header" style={{ marginBottom: "0px" }}>
              <div>
                <h2 className="join-aris-title">
                  {isUpdate ? "Confirm to delete" : "Confirm to invite"}
                </h2>
              </div>
              <button
                onClick={onCancelConfirmation}
                className="join-aris-close-btn"
              >
                <Close />
              </button>
            </div>
            <div style={{ marginBottom: "24px" }}></div>
            <p className="join-aris-subtitle">{errorMsgToBeShownOnInvite}</p>

            {errorMsg && (
              <p style={{ color: "red", textAlign: "center" }}>{errorMsg}</p>
            )}
            <div className="logout-modal-button-container">
              <div className="logout-cancel" onClick={sendInvite}>
                {isUpdate ? "Delete" : "Invite"}
              </div>
              <div
                className="logout-cancel logout-btn"
                onClick={onCancelConfirmation}
              >
                Cancel
              </div>
            </div>
          </>
        ) : (
          <>
            {!activeTab ? (
              <>
                <div
                  className="join-aris-header"
                  style={{ marginBottom: "0px" }}
                >
                  <h2 className="join-aris-title">
                    <span>{name}</span> to join Aris
                  </h2>

                  <button onClick={onClose} className="join-aris-close-btn">
                    <Close />
                  </button>
                </div>
                <div style={{ marginBottom: "24px" }}>
                  Member {currentIndex + 1} of {listedMembers || 1}: Invite
                </div>

                {/* <div
                  onClick={() => setActiveTab("sms")}
                  className="join-aris-button-flex"
                  style={{ marginBottom: "16px" }}
                >
                  <div className="join-aris-option-btn">
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "12px",
                      }}
                    >
                      <Phone />
                      via Text Message
                    </div>
                    <div>
                      <Right
                        style={{
                          padding: "5px",
                          borderRadius: "50%",
                          background: "#FFF",
                        }}
                      />
                    </div>
                  </div>
                </div> */}

                <div
                  onClick={() => setActiveTab("email")}
                  className="join-aris-button-flex"
                >
                  <div className="join-aris-option-btn">
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "12px",
                        cursor: "pointer",
                      }}
                    >
                      <Email />
                      via email
                    </div>
                    <div>
                      <Right
                        style={{
                          padding: "5px",
                          borderRadius: "50%",
                          background: "#FFF",
                        }}
                      />
                    </div>
                  </div>
                </div>
              </>
            ) : activeTab === "sms" ? (
              <>
                <div
                  className="join-aris-header"
                  style={{ marginBottom: "0px" }}
                >
                  <div>
                    <h2 className="join-aris-title">Notify via Text Message</h2>
                  </div>
                  <button
                    onClick={() => setActiveTab(null)}
                    className="join-aris-close-btn"
                  >
                    <Close />
                  </button>
                </div>
                <div style={{ marginBottom: "24px" }}>
                  Member {currentIndex + 1} of {listedMembers || 1}: Invite
                </div>
                <p
                  className="join-aris-subtitle"
                  style={{ marginBottom: "0px" }}
                >
                  Add mobile number and we will send invitation via text message
                </p>
                <p className="join-aris-input-heading">Mobile Number</p>
                <PhoneInput
                  international
                  defaultCountry="US"
                  value={memberDetails[currentIndex]?.phone || ""}
                  onChange={handlePhoneChange}
                  className="addrelationship-phoneinput"
                  placeholder="Enter phone number"
                />
              </>
            ) : (
              <>
                <div
                  className="join-aris-header"
                  style={{ marginBottom: "0px" }}
                >
                  <div>
                    <h2 className="join-aris-title">
                      {isUpdate ? "Update Email" : "Notify via Email"}
                    </h2>
                  </div>
                  <button
                    onClick={() => {
                      if (isOnlyInvite) {
                        onClose();
                      }
                      setActiveTab(null);
                    }}
                    className="join-aris-close-btn"
                  >
                    <Close />
                  </button>
                </div>
                <div style={{ marginBottom: "24px" }}>
                  Member {currentIndex + 1} of {listedMembers}
                </div>
                <p className="join-aris-subtitle">
                  {isUpdate
                    ? "Update Email and we will send connection via email"
                    : `Add ${name}'s email below to invite them to connect.`}
                </p>
                <p className="join-aris-input-heading">Email</p>
                <input
                  type="email"
                  placeholder="email@example.com"
                  className="join-aris-input"
                  value={memberDetails[currentIndex]?.email || ""}
                  onChange={(e) => handleEmailChange(e.target.value)}
                />
                {errorMsg && (
                  <p style={{ color: "red", textAlign: "center" }}>
                    {errorMsg}
                  </p>
                )}
              </>
            )}

            {activeTab && (
              <button
                onClick={handleNext}
                className="join-aris-submit-btn"
                disabled={isNextDisabled()}
                style={{ marginTop: "24px" }}
              >
                {isSubmitting
                  ? "Sending..."
                  : currentIndex + 1 < listedMembers
                  ? "Next Member"
                  : "Complete"}
                <RightArrow />
              </button>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default InvitePopup;
